export const MIN_VOICEOVER_DURATION = 100; // value in ms

export const INITIAL_VOICEOVER_VOLUME = 1;
